export enum ConnectionStatus {
    pending = 0,
    open = 1,
    close = 2,
    reconnecting = 3,
    error = 4
}
